module.exports = __webpack_public_path__ + "static/Temple Dome-c1b88f10ff472f36b09d682258dd44a7.jpg";